export default function getObjFromKey(source, key) {
  return key.split('.').reduce((obj, key) => obj[key], source);
}
